// Service TypeScript files should be AUTO-GENERATED by the Typewriter Visual Studio plugin. Do not modify this file.
import BaseApi from './BaseApi';
import BinSettingsDTO from '../models/BinSettingsDTO';
import SyncBatchDTO from '../models/SyncBatchDTO';
import DesiredPropertiesDTO from '../models/DesiredPropertiesDTO';
import SecretDTO from '../models/SecretDTO';
import PowerCycleBoardDTO from '../models/PowerCycleBoardDTO';
import SetIgnoredSolenoidsRequestDTO from '../models/SetIgnoredSolenoidsRequestDTO';
import SetIgnoredSensorRequestDTO from '../models/SetIgnoredSensorRequestDTO';
import ValvePositionDTO from '../models/ValvePositionDTO';
import UnloadDTO from '../models/UnloadDTO';
import LoadDTO from '../models/LoadDTO';
import ReportedWeatherMonitorSettingsDTO from '../models/ReportedWeatherMonitorSettingsDTO';
import SetGrainTypeRquestDTO from '../models/SetGrainTypeRquestDTO';
import ChangeHeaterModeDTO from '../models/ChangeHeaterModeDTO';
import HeaterModeOptionsRequestDTO from '../models/HeaterModeOptionsRequestDTO';
import FanOnAllowedTimeRequestDTO from '../models/FanOnAllowedTimeRequestDTO';
import FanOnAllowedTimePerWeekRequestDTO from '../models/FanOnAllowedTimePerWeekRequestDTO';
import UpdateMaxLayerGrainTempRequestDTO from '../models/UpdateMaxLayerGrainTempRequestDTO';
import LayerPercentageDTO from '../models/LayerPercentageDTO';
import DesiredFanSettingsDTO from '../models/DesiredFanSettingsDTO';
import AlertHistoryRequestDTO from '../models/AlertHistoryRequestDTO';
import DryingOperationRequestDTO from '../models/DryingOperationRequestDTO';
import GrainReconditioningOperationRequestDTO from '../models/GrainReconditioningOperationRequestDTO';
import RunFanOperationRequestDTO from '../models/RunFanOperationRequestDTO';
import RegisterProductDTO from '../models/RegisterProductDTO';
import BatchDTO from '../models/BatchDTO';
import GeneralDTO from '../models/GeneralDTO';
import ECDeviceDTO from '../models/ECDeviceDTO';
import BinAssemblyDTO from '../models/BinAssemblyDTO';
import ErrorListDTO from '../models/ErrorListDTO';
import BinInfoDTO from '../models/BinInfoDTO';
import BinDTO from '../models/BinDTO';
import ResponseResultDTO from '../models/ResponseResultDTO';
import CustomRoutineNamesDTO from '../models/CustomRoutineNamesDTO';
import UploadResultDTO from '../models/UploadResultDTO';
import PingAndBinDTO from '../models/PingAndBinDTO';
import DristackmoduleLogsDTO from '../models/DristackmoduleLogsDTO';
import OfflineBinReportDTO from '../models/OfflineBinReportDTO';
import HourlyDTO from '../models/HourlyDTO';
import MoistureForecastDTO from '../models/MoistureForecastDTO';
import ResultCameraDTO from '../models/ResultCameraDTO';
import ResponseCameraImageDTO from '../models/ResponseCameraImageDTO';
import LiveStreamForDeviceDTO from '../models/LiveStreamForDeviceDTO';
import CellStrengthDatasetDTO from '../models/CellStrengthDatasetDTO';
import OpiCableDatasetDTO from '../models/OpiCableDatasetDTO';
import BinSenseCableDatasetDTO from '../models/BinSenseCableDatasetDTO';
import AlertHistoryResponseDTO from '../models/AlertHistoryResponseDTO';
import FanHeaterHistoryChartResponseDTO from '../models/FanHeaterHistoryChartResponseDTO';
import LayerSummaryDatasetDTO from '../models/LayerSummaryDatasetDTO';
import DatasetDoubleDTO from '../models/DatasetDoubleDTO';
import CO2DatasetDTO from '../models/CO2DatasetDTO';
import MoistureRemovalDatapointDTO from '../models/MoistureRemovalDatapointDTO';
import ModeChangeHistoryDatasetDTO from '../models/ModeChangeHistoryDatasetDTO';
import FanHeaterChangeTimeDatapointDTO from '../models/FanHeaterChangeTimeDatapointDTO';
import TargetLayerDatasetDTO from '../models/TargetLayerDatasetDTO';
import RangeFinderDatapointDTO from '../models/RangeFinderDatapointDTO';
import UserLoadDatapointDTO from '../models/UserLoadDatapointDTO';
import CalculateGrainHeightResponseDTO from '../models/CalculateGrainHeightResponseDTO';
import PremierPlusSettingHistoryRecordDTO from '../models/PremierPlusSettingHistoryRecordDTO';
import AverageCyclesPremierPlusDTO from '../models/AverageCyclesPremierPlusDTO';
import PremierPlusTapestripDTO from '../models/PremierPlusTapestripDTO';
import EventDTO from '../models/EventDTO';
import PremierPlusBinDTO from '../models/PremierPlusBinDTO';

export class BinApiService extends BaseApi {

    // post: api/grainbin/SetBinSettingsOverrides?binId=${binId}
    public setBinSettingsOverrides(binId: number, binSettings: BinSettingsDTO, signal?: AbortSignal): Promise<void> {
        let url = `api/grainbin/SetBinSettingsOverrides`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, void>(binSettings, 'post', url, true, false, _signal);
    }

    // post: api/grainbin/StopCustomRoutine?binId=${binId}
    public stopCustomRoutine(binId: number, signal?: AbortSignal): Promise<void> {
        let url = `api/grainbin/StopCustomRoutine`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, void>(null, 'post', url, true, false, _signal);
    }

    // post: api/grainbin/UploadCustomRoutine?binId=${binId}
    public uploadCustomRoutine(binId: number, file: File, signal?: AbortSignal): Promise<void> {
        let url = `api/grainbin/UploadCustomRoutine`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, void>(file, 'post', url, true, false, _signal);
    }

    // post: api/grainbin/DeleteCustomRoutine?binId=${binId}&routineName=${encodeURIComponent(routineName)}
    public deleteCustomRoutine(binId: number, routineName: string, signal?: AbortSignal): Promise<void> {
        let url = `api/grainbin/DeleteCustomRoutine`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }
        if (routineName != null) {
            url += `${prefix}routineName=${encodeURIComponent(routineName)}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, void>(null, 'post', url, true, false, _signal);
    }

    // post: api/grainbin/RunCustomRoutineByName?binId=${binId}&routineName=${encodeURIComponent(routineName)}
    public runCustomRoutineByName(binId: number, routineName: string, signal?: AbortSignal): Promise<void> {
        let url = `api/grainbin/RunCustomRoutineByName`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }
        if (routineName != null) {
            url += `${prefix}routineName=${encodeURIComponent(routineName)}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, void>(null, 'post', url, true, false, _signal);
    }

    // post: api/grainbin/syncBatch
    public syncBatchWithEdge(syncBatchDTO: SyncBatchDTO, signal?: AbortSignal): Promise<BatchDTO> {
        let url = `api/grainbin/syncBatch`;

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, BatchDTO>(syncBatchDTO, 'post', url, true, false, _signal);
    }

    // get: api/grainbin/downloadallloads
    public downloadAllLoads(signal?: AbortSignal): Promise<void> {
        let url = `api/grainbin/downloadallloads`;

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, void>(null, 'get', url, true, true, _signal);
    }

    // post: api/grainbin/setBinTwin?azureDeviceId=${encodeURIComponent(azureDeviceId)}
    public setBinTwin(azureDeviceId: string, desiredPropertiesDTO: DesiredPropertiesDTO, signal?: AbortSignal): Promise<boolean> {
        let url = `api/grainbin/setBinTwin`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (azureDeviceId != null) {
            url += `${prefix}azureDeviceId=${encodeURIComponent(azureDeviceId)}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, boolean>(desiredPropertiesDTO, 'post', url, true, false, _signal);
    }

    // get: api/grainbin/getecdevice?binId=${binId}
    public getECDevice(binId: number, signal?: AbortSignal): Promise<GeneralDTO<ECDeviceDTO>> {
        let url = `api/grainbin/getecdevice`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, GeneralDTO<ECDeviceDTO>>(null, 'get', url, true, false, _signal);
    }

    // post: api/grainbin/getRemoteModTwin
    public getRemoteModuleTwin(secret: SecretDTO, signal?: AbortSignal): Promise<any> {
        let url = `api/grainbin/getRemoteModTwin`;

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, any>(secret, 'post', url, true, false, _signal);
    }

    // post: api/grainbin/getLocalModTwin
    public getLocalModuleTwin(secret: SecretDTO, signal?: AbortSignal): Promise<void> {
        let url = `api/grainbin/getLocalModTwin`;

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, void>(secret, 'post', url, true, false, _signal);
    }

    // post: api/grainbin/getWeatherForecast
    public getWeatherForecastForBin(secret: SecretDTO, signal?: AbortSignal): Promise<void> {
        let url = `api/grainbin/getWeatherForecast`;

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, void>(secret, 'post', url, true, false, _signal);
    }

    // post: api/grainbin/watchDogEndPoint
    public watchDogEndPoint(secretMsg: SecretDTO, signal?: AbortSignal): Promise<void> {
        let url = `api/grainbin/watchDogEndPoint`;

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, void>(secretMsg, 'post', url, true, false, _signal);
    }

    // get: api/grainbin/GetBinStateLogsByRange?clientDirectory=${encodeURIComponent(clientDirectory)}&startRange=${encodeURIComponent(String(startRange))}&endRange=${encodeURIComponent(String(endRange))}
    public getBinStateLogsByRange(clientDirectory: string, startRange: string, endRange: string, signal?: AbortSignal): Promise<void> {
        let url = `api/grainbin/GetBinStateLogsByRange`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (clientDirectory != null) {
            url += `${prefix}clientDirectory=${encodeURIComponent(clientDirectory)}`;
            prefix = '&';
        }
        if (startRange != null) {
            url += `${prefix}startRange=${encodeURIComponent(startRange)}`;
            prefix = '&';
        }
        if (endRange != null) {
            url += `${prefix}endRange=${encodeURIComponent(endRange)}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, void>(null, 'get', url, true, false, _signal);
    }

    // get: api/grainbin/GetGrainStateLogsByRange?clientDirectory=${encodeURIComponent(clientDirectory)}&startRange=${encodeURIComponent(String(startRange))}&endRange=${encodeURIComponent(String(endRange))}
    public getGrainStateeLogsByRange(clientDirectory: string, startRange: string, endRange: string, signal?: AbortSignal): Promise<void> {
        let url = `api/grainbin/GetGrainStateLogsByRange`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (clientDirectory != null) {
            url += `${prefix}clientDirectory=${encodeURIComponent(clientDirectory)}`;
            prefix = '&';
        }
        if (startRange != null) {
            url += `${prefix}startRange=${encodeURIComponent(startRange)}`;
            prefix = '&';
        }
        if (endRange != null) {
            url += `${prefix}endRange=${encodeURIComponent(endRange)}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, void>(null, 'get', url, true, false, _signal);
    }

    // get: api/grainbin/GetRunLogsByRange?clientDirectory=${encodeURIComponent(clientDirectory)}&startRange=${encodeURIComponent(String(startRange))}&endRange=${encodeURIComponent(String(endRange))}
    public getRunLogsByRange(clientDirectory: string, startRange: string, endRange: string, signal?: AbortSignal): Promise<void> {
        let url = `api/grainbin/GetRunLogsByRange`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (clientDirectory != null) {
            url += `${prefix}clientDirectory=${encodeURIComponent(clientDirectory)}`;
            prefix = '&';
        }
        if (startRange != null) {
            url += `${prefix}startRange=${encodeURIComponent(startRange)}`;
            prefix = '&';
        }
        if (endRange != null) {
            url += `${prefix}endRange=${encodeURIComponent(endRange)}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, void>(null, 'get', url, true, false, _signal);
    }

    // get: api/grainbin/GetPremierPlusBinStateCsvByRange?clientDirectory=${encodeURIComponent(clientDirectory)}&startRange=${encodeURIComponent(String(startRange))}&endRange=${encodeURIComponent(String(endRange))}
    public getPremierPlusBinStateCsvByRange(clientDirectory: string, startRange: string, endRange: string, signal?: AbortSignal): Promise<void> {
        let url = `api/grainbin/GetPremierPlusBinStateCsvByRange`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (clientDirectory != null) {
            url += `${prefix}clientDirectory=${encodeURIComponent(clientDirectory)}`;
            prefix = '&';
        }
        if (startRange != null) {
            url += `${prefix}startRange=${encodeURIComponent(startRange)}`;
            prefix = '&';
        }
        if (endRange != null) {
            url += `${prefix}endRange=${encodeURIComponent(endRange)}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, void>(null, 'get', url, true, false, _signal);
    }

    // get: api/grainbin/GetPremierPlusCmSensorCsvByRange?clientDirectory=${encodeURIComponent(clientDirectory)}&startRange=${encodeURIComponent(String(startRange))}&endRange=${encodeURIComponent(String(endRange))}
    public getPremierPlusCmSensorCsvByRange(clientDirectory: string, startRange: string, endRange: string, signal?: AbortSignal): Promise<void> {
        let url = `api/grainbin/GetPremierPlusCmSensorCsvByRange`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (clientDirectory != null) {
            url += `${prefix}clientDirectory=${encodeURIComponent(clientDirectory)}`;
            prefix = '&';
        }
        if (startRange != null) {
            url += `${prefix}startRange=${encodeURIComponent(startRange)}`;
            prefix = '&';
        }
        if (endRange != null) {
            url += `${prefix}endRange=${encodeURIComponent(endRange)}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, void>(null, 'get', url, true, false, _signal);
    }

    // get: api/grainbin/getbinassembly?binId=${binId}
    public getBinAssembly(binId: number, signal?: AbortSignal): Promise<BinAssemblyDTO> {
        let url = `api/grainbin/getbinassembly`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, BinAssemblyDTO>(null, 'get', url, true, false, _signal);
    }

    // post: api/grainbin/GetScript
    public getScript(secretMsg: SecretDTO, signal?: AbortSignal): Promise<void> {
        let url = `api/grainbin/GetScript`;

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, void>(secretMsg, 'post', url, true, false, _signal);
    }

    // get: api/grainbin/latestErrors?deviceId=${encodeURIComponent(deviceId)}
    public getLatestErrors(deviceId: string, signal?: AbortSignal): Promise<ErrorListDTO> {
        let url = `api/grainbin/latestErrors`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (deviceId != null) {
            url += `${prefix}deviceId=${encodeURIComponent(deviceId)}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, ErrorListDTO>(null, 'get', url, true, false, _signal);
    }

    // get: api/grainbin/latestErrorsFromDevice?deviceId=${encodeURIComponent(deviceId)}
    public getLatestErrorsFromDevice(deviceId: string, signal?: AbortSignal): Promise<ErrorListDTO> {
        let url = `api/grainbin/latestErrorsFromDevice`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (deviceId != null) {
            url += `${prefix}deviceId=${encodeURIComponent(deviceId)}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, ErrorListDTO>(null, 'get', url, true, false, _signal);
    }

    // get: api/grainbin/allBins
    public getAllBins(signal?: AbortSignal): Promise<BinInfoDTO[]> {
        let url = `api/grainbin/allBins`;

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, BinInfoDTO[]>(null, 'get', url, true, false, _signal);
    }

    // get: api/grainbin/getBinDetailFromAzure?binId=${binId}&offsetMinutes=${offsetMinutes}
    public getBinDetailFromAzure(binId: number, offsetMinutes: number, signal?: AbortSignal): Promise<BinDTO> {
        let url = `api/grainbin/getBinDetailFromAzure`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }
        if (offsetMinutes != null) {
            url += `${prefix}offsetMinutes=${offsetMinutes}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, BinDTO>(null, 'get', url, true, false, _signal);
    }

    // get: api/grainbin/getBinDetailFromDevice?binId=${binId}&offsetMinutes=${offsetMinutes}
    public getBinDetailFromDevice(binId: number, offsetMinutes: number, signal?: AbortSignal): Promise<BinDTO> {
        let url = `api/grainbin/getBinDetailFromDevice`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }
        if (offsetMinutes != null) {
            url += `${prefix}offsetMinutes=${offsetMinutes}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, BinDTO>(null, 'get', url, true, false, _signal);
    }

    // post: api/grainbin/UploadBinStateToAzure?binId=${binId}
    public uploadBinStateToAzure(binId: number, signal?: AbortSignal): Promise<ResponseResultDTO> {
        let url = `api/grainbin/UploadBinStateToAzure`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, ResponseResultDTO>(null, 'post', url, true, false, _signal);
    }

    // post: api/grainbin/UploadPremierPlusCsvLogsNow?binId=${binId}
    public uploadPremierPlusCsvLogsNow(binId: number, signal?: AbortSignal): Promise<ResponseResultDTO> {
        let url = `api/grainbin/UploadPremierPlusCsvLogsNow`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, ResponseResultDTO>(null, 'post', url, true, false, _signal);
    }

    // get: api/grainbin/getCustomRoutinesOnDisk?binId=${binId}
    public getCustomRoutinesOnDisk(binId: number, signal?: AbortSignal): Promise<CustomRoutineNamesDTO> {
        let url = `api/grainbin/getCustomRoutinesOnDisk`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, CustomRoutineNamesDTO>(null, 'get', url, true, false, _signal);
    }

    // post: api/grainbin/triggerBinStateUpload?binId=${binId}
    public triggerBinStateUpload(binId: number, signal?: AbortSignal): Promise<UploadResultDTO> {
        let url = `api/grainbin/triggerBinStateUpload`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, UploadResultDTO>(null, 'post', url, true, false, _signal);
    }

    // get: api/grainbin/pingDeviceAndGetBinDTOFromAzure?binId=${binId}&offsetMinutes=${offsetMinutes}
    public pingDeviceAndGetBinDTOFromAzure(binId: number, offsetMinutes: number, signal?: AbortSignal): Promise<PingAndBinDTO> {
        let url = `api/grainbin/pingDeviceAndGetBinDTOFromAzure`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }
        if (offsetMinutes != null) {
            url += `${prefix}offsetMinutes=${offsetMinutes}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, PingAndBinDTO>(null, 'get', url, true, false, _signal);
    }

    // post: api/grainbin/PingDevice?binId=${binId}
    public pingDevice(binId: number, signal?: AbortSignal): Promise<void> {
        let url = `api/grainbin/PingDevice`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, void>(null, 'post', url, true, false, _signal);
    }

    // post: api/grainbin/PowerCycleBoard
    public powerCycleBoard(powerCycleBoardDTO: PowerCycleBoardDTO, signal?: AbortSignal): Promise<void> {
        let url = `api/grainbin/PowerCycleBoard`;

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, void>(powerCycleBoardDTO, 'post', url, true, false, _signal);
    }

    // post: api/grainbin/RestartDristackModule?binId=${binId}
    public restartDristackModule(binId: number, signal?: AbortSignal): Promise<boolean> {
        let url = `api/grainbin/RestartDristackModule`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, boolean>(null, 'post', url, true, false, _signal);
    }

    // post: api/grainbin/GetLogsFromDristackmodule?binId=${binId}&lines=${lines}
    public getLogsFromDristackmodule(binId: number, lines: number, signal?: AbortSignal): Promise<DristackmoduleLogsDTO> {
        let url = `api/grainbin/GetLogsFromDristackmodule`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }
        if (lines != null) {
            url += `${prefix}lines=${lines}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, DristackmoduleLogsDTO>(null, 'post', url, true, false, _signal);
    }

    // get: api/grainbin/gate/open?valveId=${encodeURIComponent(valveId)}&binId=${binId}
    public openGate(valveId: string, binId: number, signal?: AbortSignal): Promise<void> {
        let url = `api/grainbin/gate/open`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (valveId != null) {
            url += `${prefix}valveId=${encodeURIComponent(valveId)}`;
            prefix = '&';
        }
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, void>(null, 'get', url, true, false, _signal);
    }

    // get: api/grainbin/gate/close?valveId=${encodeURIComponent(valveId)}&binId=${binId}
    public closeGate(valveId: string, binId: number, signal?: AbortSignal): Promise<void> {
        let url = `api/grainbin/gate/close`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (valveId != null) {
            url += `${prefix}valveId=${encodeURIComponent(valveId)}`;
            prefix = '&';
        }
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, void>(null, 'get', url, true, false, _signal);
    }

    // get: api/grainbin/spool/open?valveId=${encodeURIComponent(valveId)}&binId=${binId}
    public openSpool(valveId: string, binId: number, signal?: AbortSignal): Promise<void> {
        let url = `api/grainbin/spool/open`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (valveId != null) {
            url += `${prefix}valveId=${encodeURIComponent(valveId)}`;
            prefix = '&';
        }
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, void>(null, 'get', url, true, false, _signal);
    }

    // get: api/grainbin/spool/close?valveId=${encodeURIComponent(valveId)}&binId=${binId}
    public closeSpool(valveId: string, binId: number, signal?: AbortSignal): Promise<void> {
        let url = `api/grainbin/spool/close`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (valveId != null) {
            url += `${prefix}valveId=${encodeURIComponent(valveId)}`;
            prefix = '&';
        }
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, void>(null, 'get', url, true, false, _signal);
    }

    // get: api/grainbin/fan/on?fanId=${encodeURIComponent(fanId)}&binId=${binId}
    public turnOnFan(fanId: string, binId: number, signal?: AbortSignal): Promise<boolean> {
        let url = `api/grainbin/fan/on`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (fanId != null) {
            url += `${prefix}fanId=${encodeURIComponent(fanId)}`;
            prefix = '&';
        }
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, boolean>(null, 'get', url, true, false, _signal);
    }

    // get: api/grainbin/fans/on?binId=${binId}
    public turnOnFans(binId: number, signal?: AbortSignal): Promise<boolean> {
        let url = `api/grainbin/fans/on`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, boolean>(null, 'get', url, true, false, _signal);
    }

    // get: api/grainbin/fans/off?binId=${binId}
    public turnOffFans(binId: number, signal?: AbortSignal): Promise<boolean> {
        let url = `api/grainbin/fans/off`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, boolean>(null, 'get', url, true, false, _signal);
    }

    // get: api/grainbin/fan/off?fanId=${encodeURIComponent(fanId)}&binId=${binId}
    public turnOffFan(fanId: string, binId: number, signal?: AbortSignal): Promise<boolean> {
        let url = `api/grainbin/fan/off`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (fanId != null) {
            url += `${prefix}fanId=${encodeURIComponent(fanId)}`;
            prefix = '&';
        }
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, boolean>(null, 'get', url, true, false, _signal);
    }

    // get: api/grainbin/heater/on?binId=${binId}&fanId=${encodeURIComponent(fanId)}
    public turnOnHeater(binId: number, fanId: string, signal?: AbortSignal): Promise<boolean> {
        let url = `api/grainbin/heater/on`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }
        if (fanId != null) {
            url += `${prefix}fanId=${encodeURIComponent(fanId)}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, boolean>(null, 'get', url, true, false, _signal);
    }

    // get: api/grainbin/heaters/on?binId=${binId}
    public turnOnHeaters(binId: number, signal?: AbortSignal): Promise<boolean> {
        let url = `api/grainbin/heaters/on`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, boolean>(null, 'get', url, true, false, _signal);
    }

    // get: api/grainbin/heater/off?binId=${binId}&fanId=${encodeURIComponent(fanId)}
    public turnOffHeater(binId: number, fanId: string, signal?: AbortSignal): Promise<boolean> {
        let url = `api/grainbin/heater/off`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }
        if (fanId != null) {
            url += `${prefix}fanId=${encodeURIComponent(fanId)}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, boolean>(null, 'get', url, true, false, _signal);
    }

    // get: api/grainbin/heaters/off?binId=${binId}
    public turnOffHeaters(binId: number, signal?: AbortSignal): Promise<boolean> {
        let url = `api/grainbin/heaters/off`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, boolean>(null, 'get', url, true, false, _signal);
    }

    // get: api/grainbin/compressor/on?binId=${binId}
    public turnOnCompressor(binId: number, signal?: AbortSignal): Promise<boolean> {
        let url = `api/grainbin/compressor/on`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, boolean>(null, 'get', url, true, false, _signal);
    }

    // get: api/grainbin/compressor/off?binId=${binId}
    public turnOffCompressor(binId: number, signal?: AbortSignal): Promise<boolean> {
        let url = `api/grainbin/compressor/off`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, boolean>(null, 'get', url, true, false, _signal);
    }

    // post: api/grainbin/SetIgnoredSolenoids
    public setIgnoredSolenoids(request: SetIgnoredSolenoidsRequestDTO, signal?: AbortSignal): Promise<void> {
        let url = `api/grainbin/SetIgnoredSolenoids`;

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, void>(request, 'post', url, true, false, _signal);
    }

    // post: api/grainbin/SetIgnoredSensors?binId=${binId}
    public setIgnoredSensors(binId: number, request: SetIgnoredSensorRequestDTO, signal?: AbortSignal): Promise<void> {
        let url = `api/grainbin/SetIgnoredSensors`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, void>(request, 'post', url, true, false, _signal);
    }

    // post: api/grainbin/SetValvePositions?binId=${binId}
    public setValvePositions(binId: number, valvePositions: ValvePositionDTO[], signal?: AbortSignal): Promise<boolean> {
        let url = `api/grainbin/SetValvePositions`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, boolean>(valvePositions, 'post', url, true, false, _signal);
    }

    // post: api/grainbin/addUnload?deviceName=${encodeURIComponent(deviceName)}&binId=${binId}
    public addUnload(unload: UnloadDTO, deviceName: string, binId: number, signal?: AbortSignal): Promise<number> {
        let url = `api/grainbin/addUnload`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (deviceName != null) {
            url += `${prefix}deviceName=${encodeURIComponent(deviceName)}`;
            prefix = '&';
        }
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, number>(unload, 'post', url, true, false, _signal);
    }

    // post: api/grainbin/addLoad?deviceName=${encodeURIComponent(deviceName)}&binId=${binId}&batchNumber=${batchNumber}
    public addLoad(load: LoadDTO, deviceName: string, binId: number, batchNumber: number, signal?: AbortSignal): Promise<number> {
        let url = `api/grainbin/addLoad`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (deviceName != null) {
            url += `${prefix}deviceName=${encodeURIComponent(deviceName)}`;
            prefix = '&';
        }
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }
        if (batchNumber != null) {
            url += `${prefix}batchNumber=${batchNumber}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, number>(load, 'post', url, true, false, _signal);
    }

    // post: api/grainbin/deleteLoad?loadId=${loadId}&binId=${binId}&batchNumber=${batchNumber}
    public deleteLoad(loadId: number, binId: number, batchNumber: number, signal?: AbortSignal): Promise<boolean> {
        let url = `api/grainbin/deleteLoad`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (loadId != null) {
            url += `${prefix}loadId=${loadId}`;
            prefix = '&';
        }
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }
        if (batchNumber != null) {
            url += `${prefix}batchNumber=${batchNumber}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, boolean>(null, 'post', url, true, false, _signal);
    }

    // post: api/grainbin/deleteUnload?unloadId=${unloadId}&binId=${binId}&batchNumber=${batchNumber}
    public deleteUnload(unloadId: number, binId: number, batchNumber: number, signal?: AbortSignal): Promise<boolean> {
        let url = `api/grainbin/deleteUnload`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (unloadId != null) {
            url += `${prefix}unloadId=${unloadId}`;
            prefix = '&';
        }
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }
        if (batchNumber != null) {
            url += `${prefix}batchNumber=${batchNumber}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, boolean>(null, 'post', url, true, false, _signal);
    }

    // post: api/grainbin/SetWeatherMonitorSettings?binId=${binId}
    public setWeatherMonitorSettings(binId: number, settings: ReportedWeatherMonitorSettingsDTO, signal?: AbortSignal): Promise<ResponseResultDTO> {
        let url = `api/grainbin/SetWeatherMonitorSettings`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, ResponseResultDTO>(settings, 'post', url, true, false, _signal);
    }

    // post: api/grainbin/SetGrainType?binId=${binId}
    public setGrainType(binId: number, body: SetGrainTypeRquestDTO, signal?: AbortSignal): Promise<ResponseResultDTO> {
        let url = `api/grainbin/SetGrainType`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, ResponseResultDTO>(body, 'post', url, true, false, _signal);
    }

    // post: api/grainbin/Idle?binId=${binId}
    public idle(binId: number, signal?: AbortSignal): Promise<boolean> {
        let url = `api/grainbin/Idle`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, boolean>(null, 'post', url, true, false, _signal);
    }

    // post: api/grainbin/Fill?deviceName=${encodeURIComponent(deviceName)}&binId=${binId}
    public fill(command: any, deviceName: string, binId: number, signal?: AbortSignal): Promise<boolean> {
        let url = `api/grainbin/Fill`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (deviceName != null) {
            url += `${prefix}deviceName=${encodeURIComponent(deviceName)}`;
            prefix = '&';
        }
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, boolean>(command, 'post', url, true, false, _signal);
    }

    // post: api/grainbin/Dry?deviceName=${encodeURIComponent(deviceName)}&binId=${binId}
    public dry(command: any, deviceName: string, binId: number, signal?: AbortSignal): Promise<boolean> {
        let url = `api/grainbin/Dry`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (deviceName != null) {
            url += `${prefix}deviceName=${encodeURIComponent(deviceName)}`;
            prefix = '&';
        }
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, boolean>(command, 'post', url, true, false, _signal);
    }

    // post: api/grainbin/ChangeHeaterMode
    public changeHeaterMode(changeHeaterModeDTO: ChangeHeaterModeDTO, signal?: AbortSignal): Promise<boolean> {
        let url = `api/grainbin/ChangeHeaterMode`;

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, boolean>(changeHeaterModeDTO, 'post', url, true, false, _signal);
    }

    // post: api/grainbin/SetHeaterMode
    public setHeaterMode(options: HeaterModeOptionsRequestDTO, signal?: AbortSignal): Promise<ResponseResultDTO> {
        let url = `api/grainbin/SetHeaterMode`;

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, ResponseResultDTO>(options, 'post', url, true, false, _signal);
    }

    // post: api/grainbin/SetHeaterPlenumMcOffset?heaterPlenumMcOffset=${heaterPlenumMcOffset}&binId=${binId}
    public setHeaterPlenumMcOffset(heaterPlenumMcOffset: number, binId: number, signal?: AbortSignal): Promise<ResponseResultDTO> {
        let url = `api/grainbin/SetHeaterPlenumMcOffset`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (heaterPlenumMcOffset != null) {
            url += `${prefix}heaterPlenumMcOffset=${heaterPlenumMcOffset}`;
            prefix = '&';
        }
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, ResponseResultDTO>(null, 'post', url, true, false, _signal);
    }

    // post: api/grainbin/IgnorePlenumTemperatureSensor?ignorePlenumTemperatureSensor=${ignorePlenumTemperatureSensor}&binId=${binId}
    public ignorePlenumTemperatureSensors(ignorePlenumTemperatureSensor: boolean, binId: number, signal?: AbortSignal): Promise<ResponseResultDTO> {
        let url = `api/grainbin/IgnorePlenumTemperatureSensor`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (ignorePlenumTemperatureSensor != null) {
            url += `${prefix}ignorePlenumTemperatureSensor=${ignorePlenumTemperatureSensor}`;
            prefix = '&';
        }
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, ResponseResultDTO>(null, 'post', url, true, false, _signal);
    }

    // post: api/grainbin/SetFanRemainingOnTime
    public setFanRemainingOnTime(options: FanOnAllowedTimeRequestDTO, signal?: AbortSignal): Promise<ResponseResultDTO> {
        let url = `api/grainbin/SetFanRemainingOnTime`;

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, ResponseResultDTO>(options, 'post', url, true, false, _signal);
    }

    // post: api/grainbin/SetFanRemainingOnTimePerWeek
    public setFanRemainingOnTimePerWeek(options: FanOnAllowedTimePerWeekRequestDTO, signal?: AbortSignal): Promise<ResponseResultDTO> {
        let url = `api/grainbin/SetFanRemainingOnTimePerWeek`;

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, ResponseResultDTO>(options, 'post', url, true, false, _signal);
    }

    // post: api/grainbin/ResetFanRuntime?binId=${binId}
    public resetFanRuntime(binId: number, signal?: AbortSignal): Promise<ResponseResultDTO> {
        let url = `api/grainbin/ResetFanRuntime`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, ResponseResultDTO>(null, 'post', url, true, false, _signal);
    }

    // post: api/grainbin/UpdateMaxLayerGrainTemp
    public updateMaxLayerGrainTemp(options: UpdateMaxLayerGrainTempRequestDTO, signal?: AbortSignal): Promise<ResponseResultDTO> {
        let url = `api/grainbin/UpdateMaxLayerGrainTemp`;

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, ResponseResultDTO>(options, 'post', url, true, false, _signal);
    }

    // post: api/grainbin/SetLayersTimePercentages?binId=${binId}
    public setLayersTimePercentages(binId: number, layerPercentages: LayerPercentageDTO[], signal?: AbortSignal): Promise<ResponseResultDTO> {
        let url = `api/grainbin/SetLayersTimePercentages`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, ResponseResultDTO>(layerPercentages, 'post', url, true, false, _signal);
    }

    // post: api/grainbin/ClearRoutineEngineSteps?binId=${binId}
    public clearRoutineEngineSteps(binId: number, signal?: AbortSignal): Promise<ResponseResultDTO> {
        let url = `api/grainbin/ClearRoutineEngineSteps`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, ResponseResultDTO>(null, 'post', url, true, false, _signal);
    }

    // post: api/grainbin/RunCoreManualRoutine?binId=${binId}
    public runCoreManualRoutine(binId: number, signal?: AbortSignal): Promise<ResponseResultDTO> {
        let url = `api/grainbin/RunCoreManualRoutine`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, ResponseResultDTO>(null, 'post', url, true, false, _signal);
    }

    // post: api/grainbin/CloseAllValvesAndClearRoutines?binId=${binId}
    public closeAllValvesAndClearRoutines(binId: number, signal?: AbortSignal): Promise<ResponseResultDTO> {
        let url = `api/grainbin/CloseAllValvesAndClearRoutines`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, ResponseResultDTO>(null, 'post', url, true, false, _signal);
    }

    // post: api/grainbin/ClearManualRoutine?binId=${binId}
    public clearManualRoutine(binId: number, signal?: AbortSignal): Promise<ResponseResultDTO> {
        let url = `api/grainbin/ClearManualRoutine`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, ResponseResultDTO>(null, 'post', url, true, false, _signal);
    }

    // post: api/grainbin/RunManualLayer?binId=${binId}&targetLayer=${targetLayer}
    public runManualLayer(binId: number, targetLayer: number, signal?: AbortSignal): Promise<ResponseResultDTO> {
        let url = `api/grainbin/RunManualLayer`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }
        if (targetLayer != null) {
            url += `${prefix}targetLayer=${targetLayer}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, ResponseResultDTO>(null, 'post', url, true, false, _signal);
    }

    // post: api/grainbin/Storage?binId=${binId}
    public storage(command: any, binId: number, signal?: AbortSignal): Promise<boolean> {
        let url = `api/grainbin/Storage`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, boolean>(command, 'post', url, true, false, _signal);
    }

    // post: api/grainbin/Unload?binId=${binId}
    public unload(command: any, binId: number, signal?: AbortSignal): Promise<boolean> {
        let url = `api/grainbin/Unload`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, boolean>(command, 'post', url, true, false, _signal);
    }

    // post: api/grainbin/StartManual?binId=${binId}
    public startManual(command: any, binId: number, signal?: AbortSignal): Promise<boolean> {
        let url = `api/grainbin/StartManual`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, boolean>(command, 'post', url, true, false, _signal);
    }

    // post: api/grainbin/StopManual?binId=${binId}
    public stopManual(binId: number, signal?: AbortSignal): Promise<boolean> {
        let url = `api/grainbin/StopManual`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, boolean>(null, 'post', url, true, false, _signal);
    }

    // post: api/grainbin/Pause?binId=${binId}
    public pause(command: any, binId: number, signal?: AbortSignal): Promise<boolean> {
        let url = `api/grainbin/Pause`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, boolean>(command, 'post', url, true, false, _signal);
    }

    // post: api/grainbin/Resume?binId=${binId}
    public resume(command: any, binId: number, signal?: AbortSignal): Promise<boolean> {
        let url = `api/grainbin/Resume`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, boolean>(command, 'post', url, true, false, _signal);
    }

    // post: api/grainbin/SelfCheck?binId=${binId}
    public selfCheck(command: any, binId: number, signal?: AbortSignal): Promise<boolean> {
        let url = `api/grainbin/SelfCheck`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, boolean>(command, 'post', url, true, false, _signal);
    }

    // get: api/grainbin/getOfflineConnectionReport?binId=${binId}
    public getOfflineConnectionReport(binId: number, signal?: AbortSignal): Promise<OfflineBinReportDTO> {
        let url = `api/grainbin/getOfflineConnectionReport`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, OfflineBinReportDTO>(null, 'get', url, true, false, _signal);
    }

    // get: api/grainbin/GetHourlyForecast?binId=${binId}
    public getHourlyForecast(binId: number, signal?: AbortSignal): Promise<HourlyDTO[]> {
        let url = `api/grainbin/GetHourlyForecast`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, HourlyDTO[]>(null, 'get', url, true, false, _signal);
    }

    // get: api/grainbin/GetMoistureForecast?binId=${binId}
    public getMoistureForecast(binId: number, signal?: AbortSignal): Promise<MoistureForecastDTO[]> {
        let url = `api/grainbin/GetMoistureForecast`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, MoistureForecastDTO[]>(null, 'get', url, true, false, _signal);
    }

    // get: api/grainbin/PingTest
    public pingTest(signal?: AbortSignal): Promise<string> {
        let url = `api/grainbin/PingTest`;

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, string>(null, 'get', url, true, false, _signal);
    }

    // post: api/grainbin/updateFanSettings?binId=${binId}
    public updateSettings(settings: DesiredFanSettingsDTO, binId: number, signal?: AbortSignal): Promise<void> {
        let url = `api/grainbin/updateFanSettings`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, void>(settings, 'post', url, true, false, _signal);
    }

    // post: api/grainbin/takeCameraPicture?binId=${binId}&cameraNumber=${cameraNumber}
    public takeCameraPicture(binId: number, cameraNumber?: number | null, signal?: AbortSignal): Promise<ResultCameraDTO> {
        let url = `api/grainbin/takeCameraPicture`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }
        if (cameraNumber != null) {
            url += `${prefix}cameraNumber=${cameraNumber}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, ResultCameraDTO>(null, 'post', url, true, false, _signal);
    }

    // get: api/grainbin/getCameraImage?binId=${binId}&cameraNumber=${cameraNumber}
    public getCameraImage(binId: number, cameraNumber?: number | null, signal?: AbortSignal): Promise<ResponseCameraImageDTO> {
        let url = `api/grainbin/getCameraImage`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }
        if (cameraNumber != null) {
            url += `${prefix}cameraNumber=${cameraNumber}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, ResponseCameraImageDTO>(null, 'get', url, true, false, _signal);
    }

    // post: api/grainbin/StartLiveStream?binId=${binId}&cameraNumber=${cameraNumber}
    public startLiveStream(binId: number, cameraNumber?: number | null, signal?: AbortSignal): Promise<ResponseResultDTO> {
        let url = `api/grainbin/StartLiveStream`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }
        if (cameraNumber != null) {
            url += `${prefix}cameraNumber=${cameraNumber}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, ResponseResultDTO>(null, 'post', url, true, false, _signal);
    }

    // post: api/grainbin/StopLiveStream?binId=${binId}
    public stopLiveStream(binId: number, signal?: AbortSignal): Promise<ResponseResultDTO> {
        let url = `api/grainbin/StopLiveStream`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, ResponseResultDTO>(null, 'post', url, true, false, _signal);
    }

    // get: api/grainbin/GetStreamsForDevice?binId=${binId}
    public getStreamsForDevice(binId: number, signal?: AbortSignal): Promise<LiveStreamForDeviceDTO> {
        let url = `api/grainbin/GetStreamsForDevice`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, LiveStreamForDeviceDTO>(null, 'get', url, true, false, _signal);
    }

    // get: api/grainbin/GetCellularStrengthHistory?binId=${binId}&from=${encodeURIComponent(String(from))}&to=${encodeURIComponent(String(to))}&intervalSeconds=${intervalSeconds}
    public getCellularStrengthHistory(binId: number, from: string, to: string, intervalSeconds?: number | null, signal?: AbortSignal): Promise<CellStrengthDatasetDTO> {
        let url = `api/grainbin/GetCellularStrengthHistory`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }
        if (from != null) {
            url += `${prefix}from=${encodeURIComponent(from)}`;
            prefix = '&';
        }
        if (to != null) {
            url += `${prefix}to=${encodeURIComponent(to)}`;
            prefix = '&';
        }
        if (intervalSeconds != null) {
            url += `${prefix}intervalSeconds=${intervalSeconds}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, CellStrengthDatasetDTO>(null, 'get', url, true, false, _signal);
    }

    // get: api/grainbin/GetOPICableHistory?binId=${binId}&from=${encodeURIComponent(String(from))}&to=${encodeURIComponent(String(to))}&intervalSeconds=${intervalSeconds}
    public getOPICableHistory(binId: number, from: string, to: string, intervalSeconds?: number | null, signal?: AbortSignal): Promise<OpiCableDatasetDTO[]> {
        let url = `api/grainbin/GetOPICableHistory`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }
        if (from != null) {
            url += `${prefix}from=${encodeURIComponent(from)}`;
            prefix = '&';
        }
        if (to != null) {
            url += `${prefix}to=${encodeURIComponent(to)}`;
            prefix = '&';
        }
        if (intervalSeconds != null) {
            url += `${prefix}intervalSeconds=${intervalSeconds}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, OpiCableDatasetDTO[]>(null, 'get', url, true, false, _signal);
    }

    // get: api/grainbin/GetBinSenseCableHistory?binId=${binId}&from=${encodeURIComponent(String(from))}&to=${encodeURIComponent(String(to))}&intervalSeconds=${intervalSeconds}
    public getBinSenseCableHistory(binId: number, from: string, to: string, intervalSeconds?: number | null, signal?: AbortSignal): Promise<BinSenseCableDatasetDTO[]> {
        let url = `api/grainbin/GetBinSenseCableHistory`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }
        if (from != null) {
            url += `${prefix}from=${encodeURIComponent(from)}`;
            prefix = '&';
        }
        if (to != null) {
            url += `${prefix}to=${encodeURIComponent(to)}`;
            prefix = '&';
        }
        if (intervalSeconds != null) {
            url += `${prefix}intervalSeconds=${intervalSeconds}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, BinSenseCableDatasetDTO[]>(null, 'get', url, true, false, _signal);
    }

    // post: api/grainbin/GetAlertHistory
    public getBinAlertHistory(dto: AlertHistoryRequestDTO, signal?: AbortSignal): Promise<AlertHistoryResponseDTO> {
        let url = `api/grainbin/GetAlertHistory`;

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, AlertHistoryResponseDTO>(dto, 'post', url, true, false, _signal);
    }

    // get: api/grainbin/GetFanHeaterChart?binId=${binId}&from=${encodeURIComponent(String(from))}&to=${encodeURIComponent(String(to))}&intervalSeconds=${intervalSeconds}
    public getFanHeaterChart(binId: number, from: string, to: string, intervalSeconds?: number | null, signal?: AbortSignal): Promise<FanHeaterHistoryChartResponseDTO> {
        let url = `api/grainbin/GetFanHeaterChart`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }
        if (from != null) {
            url += `${prefix}from=${encodeURIComponent(from)}`;
            prefix = '&';
        }
        if (to != null) {
            url += `${prefix}to=${encodeURIComponent(to)}`;
            prefix = '&';
        }
        if (intervalSeconds != null) {
            url += `${prefix}intervalSeconds=${intervalSeconds}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, FanHeaterHistoryChartResponseDTO>(null, 'get', url, true, false, _signal);
    }

    // get: api/grainbin/GetLayerSummaryHistory?binId=${binId}&from=${encodeURIComponent(String(from))}&to=${encodeURIComponent(String(to))}&intervalSeconds=${intervalSeconds}
    public getLayerSummaryHistory(binId: number, from: string, to: string, intervalSeconds?: number | null, signal?: AbortSignal): Promise<LayerSummaryDatasetDTO[]> {
        let url = `api/grainbin/GetLayerSummaryHistory`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }
        if (from != null) {
            url += `${prefix}from=${encodeURIComponent(from)}`;
            prefix = '&';
        }
        if (to != null) {
            url += `${prefix}to=${encodeURIComponent(to)}`;
            prefix = '&';
        }
        if (intervalSeconds != null) {
            url += `${prefix}intervalSeconds=${intervalSeconds}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, LayerSummaryDatasetDTO[]>(null, 'get', url, true, false, _signal);
    }

    // get: api/grainbin/GetLowestLayerTemperatureHistory?binId=${binId}&from=${encodeURIComponent(String(from))}&to=${encodeURIComponent(String(to))}&intervalSeconds=${intervalSeconds}
    public getLowestLayerTemperatureHistory(binId: number, from: string, to: string, intervalSeconds?: number | null, signal?: AbortSignal): Promise<LayerSummaryDatasetDTO[]> {
        let url = `api/grainbin/GetLowestLayerTemperatureHistory`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }
        if (from != null) {
            url += `${prefix}from=${encodeURIComponent(from)}`;
            prefix = '&';
        }
        if (to != null) {
            url += `${prefix}to=${encodeURIComponent(to)}`;
            prefix = '&';
        }
        if (intervalSeconds != null) {
            url += `${prefix}intervalSeconds=${intervalSeconds}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, LayerSummaryDatasetDTO[]>(null, 'get', url, true, false, _signal);
    }

    // get: api/grainbin/GetTemperatureCableHistory?binId=${binId}&from=${encodeURIComponent(String(from))}&to=${encodeURIComponent(String(to))}&intervalSeconds=${intervalSeconds}
    public getTemperatureCableHistoryDTO(binId: number, from: string, to: string, intervalSeconds?: number | null, signal?: AbortSignal): Promise<DatasetDoubleDTO[]> {
        let url = `api/grainbin/GetTemperatureCableHistory`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }
        if (from != null) {
            url += `${prefix}from=${encodeURIComponent(from)}`;
            prefix = '&';
        }
        if (to != null) {
            url += `${prefix}to=${encodeURIComponent(to)}`;
            prefix = '&';
        }
        if (intervalSeconds != null) {
            url += `${prefix}intervalSeconds=${intervalSeconds}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, DatasetDoubleDTO[]>(null, 'get', url, true, false, _signal);
    }

    // get: api/grainbin/GetCO2History?binId=${binId}&from=${encodeURIComponent(String(from))}&to=${encodeURIComponent(String(to))}&intervalSeconds=${intervalSeconds}&hasHeadspace=${hasHeadspace}&hasPlenum=${hasPlenum}
    public getCO2History(binId: number, from: string, to: string, intervalSeconds?: number | null, hasHeadspace?: boolean | null, hasPlenum?: boolean | null, signal?: AbortSignal): Promise<CO2DatasetDTO> {
        let url = `api/grainbin/GetCO2History`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }
        if (from != null) {
            url += `${prefix}from=${encodeURIComponent(from)}`;
            prefix = '&';
        }
        if (to != null) {
            url += `${prefix}to=${encodeURIComponent(to)}`;
            prefix = '&';
        }
        if (intervalSeconds != null) {
            url += `${prefix}intervalSeconds=${intervalSeconds}`;
            prefix = '&';
        }
        if (hasHeadspace != null) {
            url += `${prefix}hasHeadspace=${hasHeadspace}`;
            prefix = '&';
        }
        if (hasPlenum != null) {
            url += `${prefix}hasPlenum=${hasPlenum}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, CO2DatasetDTO>(null, 'get', url, true, false, _signal);
    }

    // get: api/grainbin/GetAmbientPlenumHistory?binId=${binId}&from=${encodeURIComponent(String(from))}&to=${encodeURIComponent(String(to))}&intervalSeconds=${intervalSeconds}
    public getAmbientPlenumHistory(binId: number, from: string, to: string, intervalSeconds?: number | null, signal?: AbortSignal): Promise<DatasetDoubleDTO[]> {
        let url = `api/grainbin/GetAmbientPlenumHistory`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }
        if (from != null) {
            url += `${prefix}from=${encodeURIComponent(from)}`;
            prefix = '&';
        }
        if (to != null) {
            url += `${prefix}to=${encodeURIComponent(to)}`;
            prefix = '&';
        }
        if (intervalSeconds != null) {
            url += `${prefix}intervalSeconds=${intervalSeconds}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, DatasetDoubleDTO[]>(null, 'get', url, true, false, _signal);
    }

    // get: api/grainbin/GetMoistureRemovalData?binId=${binId}&from=${encodeURIComponent(String(from))}&to=${encodeURIComponent(String(to))}&intervalSeconds=${intervalSeconds}
    public getMoistureRemovalData(binId: number, from: string, to: string, intervalSeconds?: number | null, signal?: AbortSignal): Promise<MoistureRemovalDatapointDTO[]> {
        let url = `api/grainbin/GetMoistureRemovalData`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }
        if (from != null) {
            url += `${prefix}from=${encodeURIComponent(from)}`;
            prefix = '&';
        }
        if (to != null) {
            url += `${prefix}to=${encodeURIComponent(to)}`;
            prefix = '&';
        }
        if (intervalSeconds != null) {
            url += `${prefix}intervalSeconds=${intervalSeconds}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, MoistureRemovalDatapointDTO[]>(null, 'get', url, true, false, _signal);
    }

    // get: api/grainbin/GetAmbientPlenumEMCHistory?binId=${binId}&from=${encodeURIComponent(String(from))}&to=${encodeURIComponent(String(to))}&intervalSeconds=${intervalSeconds}
    public getAmbientPlenumEMCHistory(binId: number, from: string, to: string, intervalSeconds?: number | null, signal?: AbortSignal): Promise<DatasetDoubleDTO[]> {
        let url = `api/grainbin/GetAmbientPlenumEMCHistory`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }
        if (from != null) {
            url += `${prefix}from=${encodeURIComponent(from)}`;
            prefix = '&';
        }
        if (to != null) {
            url += `${prefix}to=${encodeURIComponent(to)}`;
            prefix = '&';
        }
        if (intervalSeconds != null) {
            url += `${prefix}intervalSeconds=${intervalSeconds}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, DatasetDoubleDTO[]>(null, 'get', url, true, false, _signal);
    }

    // get: api/grainbin/GetCompressorDataset?binId=${binId}&from=${encodeURIComponent(String(from))}&to=${encodeURIComponent(String(to))}&intervalSeconds=${intervalSeconds}
    public getCompressorDataset(binId: number, from: string, to: string, intervalSeconds?: number | null, signal?: AbortSignal): Promise<DatasetDoubleDTO[]> {
        let url = `api/grainbin/GetCompressorDataset`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }
        if (from != null) {
            url += `${prefix}from=${encodeURIComponent(from)}`;
            prefix = '&';
        }
        if (to != null) {
            url += `${prefix}to=${encodeURIComponent(to)}`;
            prefix = '&';
        }
        if (intervalSeconds != null) {
            url += `${prefix}intervalSeconds=${intervalSeconds}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, DatasetDoubleDTO[]>(null, 'get', url, true, false, _signal);
    }

    // get: api/grainbin/GetOperatingModeChangesDataset?binId=${binId}&from=${encodeURIComponent(String(from))}&to=${encodeURIComponent(String(to))}&intervalSeconds=${intervalSeconds}
    public getOperatingModeChangesDataset(binId: number, from: string, to: string, intervalSeconds?: number | null, signal?: AbortSignal): Promise<ModeChangeHistoryDatasetDTO> {
        let url = `api/grainbin/GetOperatingModeChangesDataset`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }
        if (from != null) {
            url += `${prefix}from=${encodeURIComponent(from)}`;
            prefix = '&';
        }
        if (to != null) {
            url += `${prefix}to=${encodeURIComponent(to)}`;
            prefix = '&';
        }
        if (intervalSeconds != null) {
            url += `${prefix}intervalSeconds=${intervalSeconds}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, ModeChangeHistoryDatasetDTO>(null, 'get', url, true, false, _signal);
    }

    // get: api/grainbin/GetFanHeaterChangeHistory?binId=${binId}&from=${encodeURIComponent(String(from))}&to=${encodeURIComponent(String(to))}&intervalSeconds=${intervalSeconds}
    public getFanHeaterChangeHistory(binId: number, from: string, to: string, intervalSeconds?: number | null, signal?: AbortSignal): Promise<FanHeaterChangeTimeDatapointDTO[]> {
        let url = `api/grainbin/GetFanHeaterChangeHistory`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }
        if (from != null) {
            url += `${prefix}from=${encodeURIComponent(from)}`;
            prefix = '&';
        }
        if (to != null) {
            url += `${prefix}to=${encodeURIComponent(to)}`;
            prefix = '&';
        }
        if (intervalSeconds != null) {
            url += `${prefix}intervalSeconds=${intervalSeconds}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, FanHeaterChangeTimeDatapointDTO[]>(null, 'get', url, true, false, _signal);
    }

    // get: api/grainbin/GetTargetLayerChart?binId=${binId}&from=${encodeURIComponent(String(from))}&to=${encodeURIComponent(String(to))}&intervalSeconds=${intervalSeconds}
    public getTargetLayerChart(binId: number, from: string, to: string, intervalSeconds?: number | null, signal?: AbortSignal): Promise<TargetLayerDatasetDTO> {
        let url = `api/grainbin/GetTargetLayerChart`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }
        if (from != null) {
            url += `${prefix}from=${encodeURIComponent(from)}`;
            prefix = '&';
        }
        if (to != null) {
            url += `${prefix}to=${encodeURIComponent(to)}`;
            prefix = '&';
        }
        if (intervalSeconds != null) {
            url += `${prefix}intervalSeconds=${intervalSeconds}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, TargetLayerDatasetDTO>(null, 'get', url, true, false, _signal);
    }

    // get: api/grainbin/GetGrainHeightsHistory?binId=${binId}&from=${encodeURIComponent(String(from))}&to=${encodeURIComponent(String(to))}&intervalSeconds=${intervalSeconds}
    public getGrainHeightsHistory(binId: number, from: string, to: string, intervalSeconds?: number | null, signal?: AbortSignal): Promise<RangeFinderDatapointDTO[]> {
        let url = `api/grainbin/GetGrainHeightsHistory`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }
        if (from != null) {
            url += `${prefix}from=${encodeURIComponent(from)}`;
            prefix = '&';
        }
        if (to != null) {
            url += `${prefix}to=${encodeURIComponent(to)}`;
            prefix = '&';
        }
        if (intervalSeconds != null) {
            url += `${prefix}intervalSeconds=${intervalSeconds}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, RangeFinderDatapointDTO[]>(null, 'get', url, true, false, _signal);
    }

    // get: api/grainbin/GetGrainHeightsHistoryUserEntered?binId=${binId}&from=${encodeURIComponent(String(from))}&to=${encodeURIComponent(String(to))}&intervalSeconds=${intervalSeconds}
    public getGrainHeightsHistoryUserEntered(binId: number, from: string, to: string, intervalSeconds?: number | null, signal?: AbortSignal): Promise<UserLoadDatapointDTO[]> {
        let url = `api/grainbin/GetGrainHeightsHistoryUserEntered`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }
        if (from != null) {
            url += `${prefix}from=${encodeURIComponent(from)}`;
            prefix = '&';
        }
        if (to != null) {
            url += `${prefix}to=${encodeURIComponent(to)}`;
            prefix = '&';
        }
        if (intervalSeconds != null) {
            url += `${prefix}intervalSeconds=${intervalSeconds}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, UserLoadDatapointDTO[]>(null, 'get', url, true, false, _signal);
    }

    // post: api/grainbin/OverrideGrainHeight?binId=${binId}&eaveHeightFt=${eaveHeightFt}&peakHeightFt=${peakHeightFt}
    public overrideGrainHeight(binId: number, eaveHeightFt?: number | null, peakHeightFt?: number | null, signal?: AbortSignal): Promise<void> {
        let url = `api/grainbin/OverrideGrainHeight`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }
        if (eaveHeightFt != null) {
            url += `${prefix}eaveHeightFt=${eaveHeightFt}`;
            prefix = '&';
        }
        if (peakHeightFt != null) {
            url += `${prefix}peakHeightFt=${peakHeightFt}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, void>(null, 'post', url, true, false, _signal);
    }

    // get: api/grainbin/CalculateGrainHeight?binId=${binId}&eaveHeightFt=${eaveHeightFt}&peakHeightFt=${peakHeightFt}
    public calculateGrainHeight(binId: number, eaveHeightFt?: number | null, peakHeightFt?: number | null, signal?: AbortSignal): Promise<CalculateGrainHeightResponseDTO> {
        let url = `api/grainbin/CalculateGrainHeight`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }
        if (eaveHeightFt != null) {
            url += `${prefix}eaveHeightFt=${eaveHeightFt}`;
            prefix = '&';
        }
        if (peakHeightFt != null) {
            url += `${prefix}peakHeightFt=${peakHeightFt}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, CalculateGrainHeightResponseDTO>(null, 'get', url, true, false, _signal);
    }

    // get: api/grainbin/getPremierPlusBinDryingSettingsHistory?binId=${binId}&from=${encodeURIComponent(String(from))}&to=${encodeURIComponent(String(to))}
    public getPremierPlusBinDryingSettingsHistory(binId: number, from?: string | null, to?: string | null, signal?: AbortSignal): Promise<PremierPlusSettingHistoryRecordDTO[]> {
        let url = `api/grainbin/getPremierPlusBinDryingSettingsHistory`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }
        if (from != null) {
            url += `${prefix}from=${encodeURIComponent(from || '')}`;
            prefix = '&';
        }
        if (to != null) {
            url += `${prefix}to=${encodeURIComponent(to || '')}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, PremierPlusSettingHistoryRecordDTO[]>(null, 'get', url, true, false, _signal);
    }

    // get: api/grainbin/getPremierPlusCycleAverages?binId=${binId}&durationSeconds=${durationSeconds}
    public getPremierPlusCycleAverages(binId: number, durationSeconds: number, signal?: AbortSignal): Promise<AverageCyclesPremierPlusDTO> {
        let url = `api/grainbin/getPremierPlusCycleAverages`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }
        if (durationSeconds != null) {
            url += `${prefix}durationSeconds=${durationSeconds}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, AverageCyclesPremierPlusDTO>(null, 'get', url, true, false, _signal);
    }

    // get: api/grainbin/getPremierPlusBinTapestrips?binId=${binId}&from=${encodeURIComponent(String(from))}&to=${encodeURIComponent(String(to))}
    public getPremierPlusBinTapestrips(binId: number, from?: string | null, to?: string | null, signal?: AbortSignal): Promise<PremierPlusTapestripDTO[]> {
        let url = `api/grainbin/getPremierPlusBinTapestrips`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }
        if (from != null) {
            url += `${prefix}from=${encodeURIComponent(from || '')}`;
            prefix = '&';
        }
        if (to != null) {
            url += `${prefix}to=${encodeURIComponent(to || '')}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, PremierPlusTapestripDTO[]>(null, 'get', url, true, false, _signal);
    }

    // get: api/grainbin/getPremierPlusEvents?binId=${binId}&from=${encodeURIComponent(String(from))}&to=${encodeURIComponent(String(to))}
    public getPremierPlusEvents(binId: number, from?: string | null, to?: string | null, signal?: AbortSignal): Promise<EventDTO[]> {
        let url = `api/grainbin/getPremierPlusEvents`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }
        if (from != null) {
            url += `${prefix}from=${encodeURIComponent(from || '')}`;
            prefix = '&';
        }
        if (to != null) {
            url += `${prefix}to=${encodeURIComponent(to || '')}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, EventDTO[]>(null, 'get', url, true, false, _signal);
    }

    // get: api/grainbin/getPremierPlusBinDetailFromAzure?binId=${binId}&offsetMinutes=${offsetMinutes}
    public getPremierPlusBinDetailFromAzure(binId: number, offsetMinutes: number, signal?: AbortSignal): Promise<PremierPlusBinDTO> {
        let url = `api/grainbin/getPremierPlusBinDetailFromAzure`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }
        if (offsetMinutes != null) {
            url += `${prefix}offsetMinutes=${offsetMinutes}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, PremierPlusBinDTO>(null, 'get', url, true, false, _signal);
    }

    // get: api/grainbin/stopPremierPlusTransferingGrain?binId=${binId}&critical=${critical}
    public premierPlus_StopTransferingGrain(binId: number, critical: boolean, signal?: AbortSignal): Promise<void> {
        let url = `api/grainbin/stopPremierPlusTransferingGrain`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }
        if (critical != null) {
            url += `${prefix}critical=${critical}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, void>(null, 'get', url, true, false, _signal);
    }

    // get: api/grainbin/stopPremierPlusDryingOperation?binId=${binId}&critical=${critical}
    public premierPlus_StopDryingOperation(binId: number, critical: boolean, signal?: AbortSignal): Promise<void> {
        let url = `api/grainbin/stopPremierPlusDryingOperation`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }
        if (critical != null) {
            url += `${prefix}critical=${critical}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, void>(null, 'get', url, true, false, _signal);
    }

    // post: api/grainbin/updatePremierPlusDryingOperation?binId=${binId}
    public premierPlus_UpdateDryingOperation(binId: number, request: DryingOperationRequestDTO, signal?: AbortSignal): Promise<void> {
        let url = `api/grainbin/updatePremierPlusDryingOperation`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, void>(request, 'post', url, true, false, _signal);
    }

    // get: api/grainbin/stopPremierPlusReconditioningOperation?binId=${binId}&critical=${critical}
    public premierPlus_StopReconditioningOperation(binId: number, critical: boolean, signal?: AbortSignal): Promise<void> {
        let url = `api/grainbin/stopPremierPlusReconditioningOperation`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }
        if (critical != null) {
            url += `${prefix}critical=${critical}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, void>(null, 'get', url, true, false, _signal);
    }

    // post: api/grainbin/updatePremierPlusReconditioningOperation?binId=${binId}
    public premierPlus_UpdateReconditioningOperation(binId: number, request: GrainReconditioningOperationRequestDTO, signal?: AbortSignal): Promise<void> {
        let url = `api/grainbin/updatePremierPlusReconditioningOperation`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, void>(request, 'post', url, true, false, _signal);
    }

    // post: api/grainbin/runPremierPlusFanOperation?binId=${binId}
    public premierPlus_RunFanOperation(binId: number, request: RunFanOperationRequestDTO, signal?: AbortSignal): Promise<void> {
        let url = `api/grainbin/runPremierPlusFanOperation`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, void>(request, 'post', url, true, false, _signal);
    }

    // post: api/grainbin/updateFanOperation?binId=${binId}
    public premierPlus_UpdateFanOperation(binId: number, request: RunFanOperationRequestDTO, signal?: AbortSignal): Promise<void> {
        let url = `api/grainbin/updateFanOperation`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, void>(request, 'post', url, true, false, _signal);
    }

    // get: api/grainbin/stopFanOperation?binId=${binId}
    public premierPlus_StopFanOperation(binId: number, signal?: AbortSignal): Promise<void> {
        let url = `api/grainbin/stopFanOperation`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (binId != null) {
            url += `${prefix}binId=${binId}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, void>(null, 'get', url, true, false, _signal);
    }

    // post: api/grainbin/registerProduct
    public registerProduct(request: RegisterProductDTO, signal?: AbortSignal): Promise<void> {
        let url = `api/grainbin/registerProduct`;

        url = url.replace(/null|undefined/gi, '');
        const _signal = signal ?? new AbortController().signal;
        return this.SendRequest<any, void>(request, 'post', url, true, false, _signal);
    }
}
var service = new BinApiService();
export default service;
